import { api } from './api';

export interface ContactFormSubmission {
  name: string;
  role: string;
  instituteName: string;
  contactNumber: string;
  email?: string;
  numberOfStudents?: string;
  numberOfCampuses?: string;
  message?: string;
}

export interface ContactFormResponse {
  success: boolean;
  submissionId: string;
  emailSent: boolean;
  message: string;
}

export const contactFormApi = {
  submitContactForm: async (data: ContactFormSubmission): Promise<ContactFormResponse> => {
    const response = await api.post('/contact-form', data);
    return response.data;
  },
};
